/**
* @name APP Integration
* @autor VigneshKumar Somayaji
* @description
* # name controller --> executeDataController
*/

export default class executeDataController {

	constructor($scope, $http, $resource, $timeout, ngNotify, UserInfoConstant, $state, $interval, $cookies, SERVICE_URL_CONSTANT, integrationServices, $filter) {
		$scope.id = 0
		$scope.setProcess = []
		this.$translate = $filter('translate')
		$scope.executiondata = [{'execution_status' : 0}]//estado inicial para deshabilitar el boton
		let sumInterval = {}

		$scope.Ejecutar = (title, fid)  => {
			const executorProcess = $scope.setProcess
			$scope.pingMethod = function pingMethod() {
				const cookiesProcess = $scope.setProcess
                   
				if (typeof cookiesProcess[0] !== 'undefined' && typeof cookiesProcess[0].fid !== 'undefined') {
					integrationServices.services.pingEtlExecutable({ id: cookiesProcess[0].processID }).
					$promise.then((response) => {
						const pingEtlExecutable = response.executablefeatures[0]
						
						if (pingEtlExecutable.id_status != 1 && pingEtlExecutable.id_status != 2) {
							$('#execution_button_' + pingEtlExecutable.fid).addClass('bg-success')
							$('#execution_button_' + pingEtlExecutable.fid).html(pingEtlExecutable.statues)
							$('#execution_button_' + pingEtlExecutable.fid).removeClass('bg-warning')
							delete cookiesProcess[0]
							//$cookies.remove('setProcess');
							$scope.setProcess = []
							// $cookies.putObject('setProcess',cookiesProcess);
							$scope.executiondata[0].execution_status = pingEtlExecutable.id_status // para volver a dejar clickeable el boton
						} 
					}, (err) => {
						ngNotify.set(this.$translate('MSG_ERROR'), 'error')
					})					
				} else {
					$interval.cancel(sumInterval)
					$scope.setProcess = []
				}
			}

			if (executorProcess.length == 0 || executorProcess[0].fid == undefined) {
				const param = { 
					fid             : fid, 
					jobname         : $scope.executiondata[0].ds_job_name,
					//execution_status: $scope.executiondata[0].execution_status,
				}
				$scope.executiondata[0].execution_status=1
				$('#execution_button_' + fid).addClass('bg-warning')
				$('#execution_button_' + fid).html('En ejecucion')
				$('#execution_button_' + fid).removeClass('label-danger')

				integrationServices.services.setExecutionDetails(param).$promise.then((dataReturn) => {
					if(dataReturn.error==true) {
						ngNotify.set(this.$translate('WAIT_UNTIL_PROCESS_ENDS'), 'error')
					} 
					sumInterval = $interval($scope.pingMethod, 30000)
					$scope.id = dataReturn.data
					$scope.setProcess.push({ 
						processID: dataReturn.data,
						title    : title,
						fid      : fid,
					})					
					
				}, (err) => {
					ngNotify.set(this.$translate('MSG_ERROR'), 'error')
				})
			} else {
				if (sumInterval !== null && executorProcess[0].fid == fid) {
					sumInterval = $interval($scope.pingMethod, 5000)
					$('#execution_button_' + fid).addClass('bg-warning')
					$('#execution_button_' + fid).html('En ejecucion')
					$('#execution_button_' + fid).removeClass('label-danger')
					$('#execution_button_' + fid).removeClass('bg-success')
				} else {
					ngNotify.set(this.$translate('WAIT_UNTIL_PROCESS_ENDS'), 'error')
				}
			}
		}    

		/// process not terminated

		integrationServices.services.getExecutionDetails().$promise.then((dataReturn) => {
			
			if (dataReturn.data.length != 0) {
				
				$scope.executiondata = dataReturn.data
				const execution=[]
				for (let i in dataReturn.data) {
					
					if (dataReturn.data[i].execution_status == 1 || dataReturn.data[i].execution_status == 2) {
						execution.push({ 
							processID: dataReturn.data[i].exection_id,
							title    : dataReturn.data[i].feature_name,
							fid      : dataReturn.data[i].fid,
						})						
					}
				}

				try {
					const ejap = execution
					$scope.setProcess=execution
					if (typeof ejap !== 'undefined' && ejap.length > 0 && ejap[0] !== null) {
						$scope.Ejecutar(ejap[0].title, ejap[0].fid)
						$timeout(function () {
							$('#execution_button_' + ejap[0].fid).addClass('bg-warning')
							$('#execution_button_' + ejap[0].fid).html('En ejecucion')
							$('#execution_button_' + ejap[0].fid).removeClass('bg-success')
							$('#execution_button_' + ejap[0].fid).removeClass('bg-danger')
						}, 3000)
					}        
				} catch (e) {
					console.log('process  terminated', e)
				}
				
			}
		}, (err) => {
			ngNotify.set(this.$translate('MSG_ERROR'), 'error')
		})
	}

}

executeDataController.$inject = [ '$scope', '$http', '$resource', '$timeout', 'ngNotify', 'UserInfoConstant', '$state', '$interval', '$cookies', 'SERVICE_URL_CONSTANT', 'integrationServices', '$filter' ]




// WEBPACK FOOTER //
// ./src/app/integration-front/integration_action/execute/executeDataController.js